// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"594":"9ac2a150","822":"78cb96dc","847":"78702d9a"}[chunkId] + ".js";
};